import React from "react";
import "./style.scss";

const ProgressBar = ({ step, opacity }) => {
  return (
    <div className={"progress"}>
      <div className="progress-wrapper" style={{ opacity: `${opacity}` }}>
        <div
          className="progress-bar progress-bar-striped bg-info"
          style={{ width: (step / 14) * 100 + "%" }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
